import { render, staticRenderFns } from "./CompensationHub.vue?vue&type=template&id=5536b116&scoped=true&"
import script from "./CompensationHub.vue?vue&type=script&lang=js&"
export * from "./CompensationHub.vue?vue&type=script&lang=js&"
import style0 from "./CompensationHub.vue?vue&type=style&index=0&id=5536b116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536b116",
  null
  
)

export default component.exports